import { BaseQueryFn, FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { createApi, FetchArgs, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { getBffBaseUrl } from '../../config/runtime'

import { prepareClientVersionHeaders } from './clientVersionHeader'

const DEFAULT_BFF_BASE_URL = '/bff'

const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
	args,
	api,
	extraOptions,
) => {
	const baseUrl = (await getBffBaseUrl()) || DEFAULT_BFF_BASE_URL
	const baseQuery = fetchBaseQuery({
		baseUrl,
		credentials: 'include',
		prepareHeaders: prepareClientVersionHeaders,
	})

	return baseQuery(args, api, extraOptions)
}

export type OnboardingRoutingDecision =
	| { action: 'show-landing' }
	| { action: 'show-agreement' }
	| { action: 'redirect-to-organization'; organizationId: string }
	| { action: 'show-create-organization' }

type OnboardingRoutingArgs = {
	licensePlan?: string
	lastOrganizationId?: string
}

export const bffApi = createApi({
	reducerPath: 'bffApi',
	baseQuery: dynamicBaseQuery,
	keepUnusedDataFor: 0,
	endpoints: (builder) => ({
		onboardingRouting: builder.query<OnboardingRoutingDecision, OnboardingRoutingArgs>({
			query: ({ licensePlan, lastOrganizationId }) => ({
				url: '/onboarding/routing',
				params: { licensePlan, lastOrganizationId },
			}),
		}),
	}),
})

export const { useOnboardingRoutingQuery } = bffApi
